<template>
    <div  class="container-fluid" >

            <div @touchmove.prevent @mousewheel.prevent>
                <div class="back" @click="back">
                <input type="button" class="inp_btn"  />
                <span class="back_btn">返回</span>
            </div>
                <h3 style="margin-bottom:0.25rem;">{{sweepInfo.title}}</h3>
                <div class="sweepTop" style="margin-bottom:0.2rem;">
                    <span>{{sweepInfo.noticeSegmentName}}</span>
                    <span>{{sweepInfo.areaname}}</span>
                </div>
                <div class="flex row" style="margin-bottom:0.2rem;">发布时间:{{sweepInfo.infoPublishTime}}</div>
                <div class="flex row" style="margin-bottom:0.2rem;">招标单位：:{{sweepInfo.zhaoBiaoUnit}}</div>
                <div class="flex row" style="margin-bottom:0.2rem;">招标编号：{{sweepInfo.xmNumber}}</div>
                <div class="flex row" style="margin-bottom:0.2rem;">招标估价：{{sweepInfo.budgetAmount}}</div>
                <div class="flex row" style="margin-bottom:0.2rem;">招标联系人：{{sweepInfo.zhaoRelationName}}</div>
                <div class="flex row" style="margin-bottom:0.2rem;">招标代理机构：{{sweepInfo.agentUnit}}</div>
                <div class="flex row" style="margin-bottom:0.2rem;">代理人联系人：{{sweepInfo.agentRelationName}}</div>
                <div style="margin-bottom:0.2rem;">详情</div>
            </div>


            <div v-html="content" style="margin-bottom:0.2rem;"></div>
            <div v-for="(item,index) in sweepInfo.fileList" :key="index" style="margin-bottom:0.2rem;">
                <a :href="item.localLinkUrl" style="color:#268FFE">{{item.fileName}}</a>
            </div>
		</div>
</template>

<script>

// import '../assets/lib/qrcode'
// import '../assets/lib/zepto'
// import $ from 'jquery'
// import { chunk } from '../assets/js/chunk.js';
import { queryPage,queryPageSolrfile,queryPageDocument,query,save,createKeyword} from '../api/bidding'
export default {
    name: "pass",
    data(){
        return{
          list:[],
          name:'详情',
          sweepInfo:{
              id:'',
              contentId:'',
              noticeSegmentType:'',
              noticeSegmentName:'',
              messageType:'',
              xmNumber:'',
              title:'',
              areaname:'',
              zhaoBiaoUnit:'',
              zhaoRelationName:'',
              zhaoRelationWay:'',
              agentUnit:'',
              agentRelationName:'',
              agentRelationWay:'',
              infoPublishTime:'',
              updatetimeStr:'',
              content:'',
              budgetAmount:'',
              fileTp:'',
              fileName:'',
              fileSize:'',
              localLinkUrl:''
          }
        }
    },
    computed:{

    },
    mounted(){
        let obj = {
            // id:this.$route.query.id,
            contentId:this.$route.query.contentId,
        }
        query(obj).then(res=>{
            if(res.data.code=='000000'){
            console.log(res.data.data,'query')
            this.sweepInfo = res.data.data
            this.content = res.data.data.content.replace(/<td/g,"<td style='border: 1px solid #ccc;white-space: nowrap;'")
            // this.content = res.data.data.content.replace('吉祥',"替换")
            // let list = res.data.data.data
            // list.map(item=>{
            //     item.content = JSON.parse(item.content)
            // })
            // this.list = list
            // this.name =list[0].popTitle
            // console.log(list,'list')

            }
        })

    },
    methods:{
        back(){
            // this.$router.go(-1);//返回上一层
            this.$router.push({ path: "/bidding"});//返回上一层
        },
        base64ImgtoFile(dataurl, filename = 'file') {
            let arr = dataurl.split(',')
            let mime = arr[0].match(/:(.*?);/)[1]
            let suffix = mime.split('/')[1]
            let bstr = atob(arr[1])
            let n = bstr.length
            let u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], `${filename}.${suffix}`, {
                type: mime
            })
        },
        // 确定
        addimgs(){
            let imgs = $(".imgsText")[0].src;
            // console.log(imgs,'imgs')
            // let imgURl=this.base64ImgtoFile(imgs)
            // var reader = new FileReader();
            // reader.readAsDataURL(imgURl);
            getSampleByEwm({data:JSON.stringify(imgs)}).then(res=>{
                if(res.data.code==0){
                    console.log('请求成功')
                }
            })

        },
        activated () {
            const self = this
            if (window.plus) {
            self.plusReady()
            } else {
            document.addEventListener('plusready', self.plusReady, false)
            }

            document.addEventListener('DOMContentLoaded', function () {
            // alert('DOMLoaded')
            self.domready = true
            self.plusReady()
            }, false)

            setTimeout(function () {
            self.sweep() // 扫码函数
            }, 1000)
        },

        //创建
        plusReady () {
            const self = this
            // 获取窗口
            self.scan = new plus.barcode.Barcode('code')
            self.scan.onmarked = self.onmarked
            },
            // 开始扫码
            sweep () {
            const self = this
            self.scan.start()
            },
            onmarked (type, result) {
            let t = this
            var text = '未知: '

            switch (type) {
                case plus.barcode.QR:
                type = 'QR'
                break
                case plus.barcode.EAN13:
                type = 'EAN13'
                break
                case plus.barcode.EAN8:
                type = 'EAN8'
                break
                default:
                type = '其他' + type
                break
            }
            result = result.replace(/\n/g, '')
            if (result.indexOf('http://') == 0 || result.indexOf('https://') == 0) {
                plus.nativeUI.confirm(result, function (i) {
                if (i.index == 0) {
                    // self.back() // 返回上个页面

                    plus.runtime.openURL(result)
                    console.log(result) // 扫出来的值
                    t.scan.close() //扫码成功后关闭扫码
                    t.$router.push({path: 'Info', query: {id: result}})   // 跳转到对应的页面
                } else {
                    // self.back() // 返回上个页面
                    console.log(result)
                    t.scan.close()
                    window.localStorage.scan = result
                    t.$router.push({path: 'Info', query: {id: result}})
                }
                }, '', ['打开', '取消'])
            } else {
                // self.back() // 返回上个页面
                console.log(result)
            }
        }
    },

}
</script>
<style scoped>
    .container-fluid{
        /* top: 0;
        left: 0;
        right: 0;
        bottom: 0; */
        padding: 0.2rem;
        box-sizing: border-box;
        /* background: url(../assets/images/bj_saoma.png); */
        overflow: auto;
    }
    .sweepTop{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    p {
        text-align: center;
        color: white;
        font-size: 0.3rem;
    }
    .back{
        display: flex;
        flex-direction: row;
        align-items: center;
        /* padding-left: 0.1rem; */
        /* padding-top: 0.1rem; */
        vertical-align: middle;
        margin-bottom: 0.4rem;
    }
    .back_btn{
        margin-top: 0.1rem;
        margin-left: 0.1rem;
    }

    .btn_span {
        position: absolute;
        top: 1.15rem;
        left: 0.42rem;
        text-shadow: 0.03rem 0.03rem 0.2rem #1E9FFF;
        color: #1E9FFF;
        font-size: 0.18rem;
    }


    .p_span {
        margin-top:0.5rem;
        font-size: 0.6rem;
        text-align: center;
    }
    .p_img {
        background: url(../assets/images/组7.png) no-repeat;
        width: 2.07rem;
        height: 0.22rem;
        margin: 0.1rem auto;
    }

    #div {
        height: 3rem;
        background-color: white;
        border-radius: 0.05rem;
        position: absolute;
        top: 2rem;
        overflow-x: auto;
        overflow-y: auto;
    }

    #sample_btn {
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-tap-highlight-color: transparent;
        outline: none;
    }
    /* table{
        width: 90%;
        word-wrap:break-word;
        word-break:break-all;
        table-layout:fixed;
    } */
    .inp_btn {
        border: 0;
        background: url(../assets/images/back.png) no-repeat;
        /* position: fixed;
        top: 0px;
        left: 0.1rem; */
        height: 0.4rem;
        width: 0.4rem;
        margin-top: 0.1rem;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-tap-highlight-color: transparent;
        outline: none;
    }
    .span_pass {
        font-size: 0.3rem;
        font-weight: 500;
        position: fixed;
        margin-top: 0.05rem;
        text-align: center;
    }
    .saoma_box{
        width: 3.1rem;
        height: 3.1rem;
        margin:  1.48rem auto;
        border-radius: 50%;
        background: #fff;
    }
    .saoma_imgs{
        width: 1.62rem;
        height: 1.48rem;
        background-image: url(../assets/images/saomaCode.png)no-repeat;
    }
    .imgsText{
        display: block;
        width: 3.49rem;
        height: 2.22rem;
        background: #fff;
        margin: 0 auto;
        border-radius: 0.1rem;
    }
    .imgs_btn{
        display: block;
        width: 1.898rem;
        height: 0.56rem;
        line-height: 0.56rem;
        text-align: center;
        background: #fff;
        font-size: 0.24rem;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #738DEE;
        margin: 0 auto;
        margin-top: 0.6rem;
        border-radius: 0.1rem;
        margin-bottom: 0.4rem;
    }
    /* 2022-01-20 */
    table{
        border-collapse: collapse;
        padding: 0;
        border: 1px solid #ccc;
        border-spacing: 0;
        font-size: 100%;
        font-weight: 400;
        vertical-align: baseline;
        display: table;
        box-sizing: border-box;
        text-indent: initial;
        line-height: 25px;
        color: #323232;
    }
    tbody,tr,td,span{
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        font-weight: 400;
        vertical-align: baseline;

    }
    tbody{
        display: table-row-group;
    }
    /* tr{
        display: table-row;
    } */
    td{
        display: table-cell;
        border: 1px solid #ccc;
        white-space: nowrap;
    }
    table tr td{
        border: 1px solid #ccc;
    }
    table td{
        white-space: nowrap;
    }
    .detail-highlight {
        color: #faad14!important;
    }

</style>
